module.exports = {
      id: "islide-more-pic2-usage",
      viewBox: "0 0 500 304",
      url: __webpack_public_path__ + "images/js_src_vue/page_islide_landing/sprite.30abe696.svg#islide-more-pic2-usage",
      toString: function () {
        return this.url;
      }
    }